// TSS vite/02 — simulated card form. No payment gateway is involved: the
// checkout validates shape only and then resolves after a delay.

export const CARD_NUMBER_LENGTH = 16;
export const CARD_GROUP_SIZE = 4;
export const CVC_MIN_LENGTH = 3;
export const CVC_MAX_LENGTH = 4;
export const CARD_HOLDER_MAX_LENGTH = 60;
export const EXPIRY_MAX_YEARS_AHEAD = 15;

export const PAYMENT_STATUS = {
    IDLE:       'idle',
    PROCESSING: 'processing',
    SUCCESS:    'success',
};

// Offered behind a "usar tarjeta de prueba" button so nobody has to invent
// digits to see the flow end to end.
export const TEST_CARD = {
    holder: 'JUAN PEREZ',
    number: '4242424242424242',
    expiry: '12/30',
    cvc:    '123',
};
